// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__2dCYf","form":"styles_form__3UYof"};